<script setup lang="ts">
import { ROUTES } from '~/utils/constants'
interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
  link?: boolean
  to?: string
  /**
   * Whether the logo is placed on a dark background.
   * If true, adds a stylized container to the logo image.
   */
  onDark?: boolean
  collapsed?: boolean
  collapsedSrc?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  showText: false,
  link: true,
  to: ROUTES.HOME,
  onDark: false,
  collapsed: false,
  collapsedSrc: '/favicon.png',
})

const sizeClasses = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
  xl: 'h-12',
}

const textClasses = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl',
}
</script>

<template>
  <component
    :is="link ? 'NuxtLink' : 'div'"
    v-bind="link ? { to: props.to } : {}"
    class="flex items-center gap-2.5 group transition-all duration-300"
    :class="{ 'cursor-pointer': link }"
  >
    <div
      class="relative flex items-center justify-center shrink-0"
      :class="{
        'bg-white p-1 rounded-lg shadow-sm border border-gray-200/50': onDark,
      }"
    >
      <!-- Glow effect on hover -->
      <div
        class="absolute inset-0 bg-primary-500/20 blur-xl rounded-full scale-0 group-hover:scale-150 transition-transform duration-500 opacity-0 group-hover:opacity-100"
      />

      <img
        :src="collapsed ? collapsedSrc : '/images/tcf-logo.jpg'"
        :alt="collapsed ? 'TCF Icon' : 'TCF Logo'"
        class="relative z-10 w-auto object-contain transition-all duration-500 ease-out"
        :class="[sizeClasses[size], { 'rounded-md': collapsed }]"
      />
    </div>

    <span
      v-if="showText && !collapsed"
      class="font-bold tracking-tight text-gray-900 dark:text-white transition-colors duration-300"
      :class="textClasses[size]"
    >
      TCF Canada
    </span>
  </component>
</template>

<style scoped>
/* Optional: additive styles if needed */
</style>
